import { ILegalFormDTO } from "@modeso/types__aumico-lib-settings-be";
import { ProjectMetaInformationDto } from "../../../../aumico-lib-projects-fe/src/lib";

export interface ProjectToCopyFrom extends ProjectMetaInformationDto {
    annualReportEncryptedId: string;
    legalForm: ILegalFormDTO | null;
}